import {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"
import useHttpHandler from "../../../hooks/httpHandler";
import {toast} from "react-toastify";
const usePayments = () => {
    const {post, get, deleteItem} = useHttpHandler()
    const navigate = useNavigate()
    const [cardsList, setCardList] = useState(null)
    const [isModal, setIsModal] = useState(false);

    const [isConfirmDeleteModal, setIsConfirmDeleteModal] = useState(false);
    const [paymentIDToDelete, setPaymentIDToDelete] = useState(null);
    const onOpenModal = () => {
        setIsModal(true);
    }
    const onCloseModal = () => {
        setIsModal(false);
    }

    const onClosConfirmDeleteModal = () => {
        setIsConfirmDeleteModal(false);
    }

    const onOpenConfirmDeleteModal = (id) => {
        setPaymentIDToDelete(id)
        setIsConfirmDeleteModal(true);
    }


    const getCards = (isDeleteCard = false) => {
        get('card/get-all').then((res) => {
            const data = res.data
            if(isDeleteCard) {
                setCardList(data.cards)
            }
            if(data.cards.length > 0) {
                setCardList(data.cards)
                onCloseModal()
            }
        }).catch(err => {

        })
    }

    const deleteCard = () => {
        deleteItem('card/'+paymentIDToDelete ).then((res) => {
            toast.success('Card deleted successfully')
            onClosConfirmDeleteModal()
            getCards(true)
        }).catch(()=>{
            onClosConfirmDeleteModal()
        })
    }

    const MINUTE_MS = 5000;

    useEffect(() => {
        if(isModal) {
            const interval = setInterval(() => {
                getCards()
            }, MINUTE_MS);
            return () => clearInterval(interval);
        }
    }, [isModal])

    useEffect(()=>{
        getCards()
    },[])

    return (
        {
            isModal,
            onOpenModal,
            onCloseModal,
            cardsList,
            deleteCard,

            isConfirmDeleteModal,
            onOpenConfirmDeleteModal,
            onClosConfirmDeleteModal,
            paymentIDToDelete
        }
    )
}

export default usePayments